import { ComponentType } from "../../data";
import { ComponentTypeMapper } from "../ComponentTypeMapper";
import { EventsBySportIdRequest } from "sb-bff-integration";
export var mapEventComponent = function (event, cardConfig, isMiniCard) {
    var currentSportId = cardConfig[event.sportId] ? event.sportId : "0";
    event.componentType = getComponentType(event, isMiniCard);
    if (event.type === EventsBySportIdRequest.EventTypesEnum.Fixture.toString()) {
        var cardType = cardConfig[currentSportId].cardType;
        event.cardType = cardType;
    }
    return event;
};
var getComponentType = function (event, isMiniCard) {
    return ComponentTypeMapper[event.type] ? ComponentTypeMapper[event.type](isMiniCard, event.isLive) : ComponentType.EventCard;
};
//# sourceMappingURL=mapEventComponent.js.map